import { API_HOST_URL } from 'App/Dataman-Backend';

export const API_INTERFACE_USER_SESSIONS = `${API_HOST_URL}/api/interface_user_sessions`;
